document.addEventListener('submit', (event) => {
  const form = event.target.closest('.aw-footer__form, .aw-popup__form, .newsletter-form');
  if (!form || !form.checkValidity()) return;

  const button = form.querySelector('[type="submit"]');
  if (!button || button.disabled) {
    if (button?.disabled) event.preventDefault();
    return;
  }

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.dataset.originalLabel = button.textContent;

  const loadingLabel = button.dataset.loadingLabel;
  if (loadingLabel) button.textContent = loadingLabel;
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('.aw-footer__form [type="submit"], .aw-popup__form [type="submit"], .newsletter-form [type="submit"]').forEach((button) => {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (button.dataset.originalLabel) button.textContent = button.dataset.originalLabel;
  });
});
